export var ModalType;
(function (ModalType) {
    ModalType["Validation"] = "validation";
    ModalType["Info"] = "info";
})(ModalType || (ModalType = {}));
